<template>
  <div class="Page" >
    <div class="container" style="width: 20cm;margin-left: -1.5cm;">
      <h1 style="text-align: center;font-size: 16px;height: 30px;line-height: 30px;font-weight: normal;margin-top: 1cm">青岛升平电气有限公司-销售送货单</h1>
      <table width="755" style="width: 755px;margin: -23px auto 0;border-collapse: collapse;text-align: center;color: #000;">
        <tbody>
        <!--        固定表格结构-->
        <tr style="visibility: hidden;color: transparent">
          <td style="padding: 4px 7px;width: 80px" width="80">ABCDEFGH</td>
          <td colspan="2" style="padding: 4px 7px;width: 450px" width="450">ABCDEFGHIABCDEFGHIABCDEFGHIABCDEFGHIABCDEFGHIABCDEFGHI</td>
          <td style="padding: 4px 7px;width: 120px" width="120">ABCDEFGHGHGH</td>
          <td colspan="2" style="padding: 4px 7px; width: 210px" width="210">ABCDEFGHABCDEFGHABCDEFGHIJ</td>
        </tr>
        <tr>
          <td style="padding: 4px 7px;width: 80px;text-align: left" width="80" colspan="3">送货单号:{{report.order_id?.replace(/-/g,'')}}</td>
          <td style="padding: 4px 7px 4px 30px;width: 120px;text-align: left;" width="120" colspan="3">送货日期:{{report.out_date}}</td>
        </tr>
        <tr>
          <td style="border: 1px solid #333; padding: 4px 7px;width: 80px" width="80">客户名称</td>
          <td colspan="2" style="border: 1px solid #333; border-left: none;padding: 4px 7px;width: 450px" width="450">{{report.cname}}</td>
          <td style="border: 1px solid #333;border-left: none; padding: 4px 7px;width: 120px" width="120">业务员</td>
          <td colspan="2" style="border: 1px solid #333;padding: 4px 7px; width: 210px" width="210">{{report.salesman}}</td>
        </tr>
        <tr style="height: 24px;">
          <td style="border: 1px solid #333;border-top: none;padding: 4px 7px;width: 80px" width="80">生产计划</td>
          <td colspan="2" style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 450px" width="450">{{report.plan}}</td>
          <td style="border: 1px solid #333;border-left: none; border-top: none ;padding: 4px 7px;width: 120px" width="120">备注</td>
          <td colspan="2" style="border: 1px solid #333;border-top:none;padding: 4px 7px; width: 210px;">{{report.remark}}</td>
        </tr>

        <tr>
          <td style="border: 1px solid #333;border-top: none;padding: 4px 7px;width: 80px" width="80">序号</td>
          <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 350px" width="350">产品品号</td>
          <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 100px" width="100">产品名称</td>
          <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 120px" width="120">产品规格型号</td>
          <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 80px" width="80">数量</td>
          <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 130px" width="130">备注</td>
        </tr>
        <tr v-for="n in 10" :key="n">
          <template v-if="(page + 1 == total && n == 10)">
            <td style="border: 1px solid #333;border-top: none;padding: 4px 7px;width: 80px" width="80"></td>
            <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 350px" width="350"></td>
            <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 100px" width="100"></td>
            <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 120px" width="120">数量合计</td>
            <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 80px" width="80">{{report.total}}</td>
            <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 130px" width="130"></td>
          </template>
          <template v-else-if="n <= 8">
            <td style="border: 1px solid #333;border-top: none;padding: 4px 7px;width: 80px" width="80">{{(report.items?.[(page * 8 + n - 1)]?.pcode) ? (n + page * 8) : '&nbsp;'}}</td>
            <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 350px" width="350">{{report.items?.[(page * 8 + n - 1)]?.pcode}}</td>
            <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 100px" width="100">{{report.items?.[(page * 8 + n - 1)]?.pname}}</td>
            <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 120px" width="120">{{report.items?.[(page * 8 + n - 1)]?.pmodel}}</td>
            <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 80px" width="80" v-html="dot(report.items?.[(page * 8 + n - 1)]?.amount)"></td>
            <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 130px" width="130">{{report.items?.[(page * 8 + n - 1)]?.remark}}</td>
          </template>
          <template v-else>
            <td style="border: 1px solid #333;border-top: none;padding: 4px 7px;width: 80px" width="80" :style="(page + 1 < total) ? 'border: 1px solid transparent' : ''">&nbsp;</td>
            <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 350px" width="350" :style="(page + 1 < total) ? 'border: 1px solid transparent' : ''"></td>
            <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 100px" width="100" :style="(page + 1 < total) ? 'border: 1px solid transparent' : ''"></td>
            <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 120px" width="120" :style="(page + 1 < total) ? 'border: 1px solid transparent' : ''"></td>
            <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 80px" width="80" :style="(page + 1 < total) ? 'border: 1px solid transparent' : ''"></td>
            <td style="border: 1px solid #333; border-left: none;border-top: none;padding: 4px 7px;width: 130px" width="130" :style="(page + 1 < total) ? 'border: 1px solid transparent' : ''"></td>
          </template>
        </tr>
<!--        固定表格结构-->
        <tr style="visibility: hidden;color: transparent">
          <td style="border: 1px solid transparent;border-top: none;padding: 4px 7px;width: 80px" width="80">ABCDEFGH</td>
          <td style="border: 1px solid transparent; border-left: none;border-top: none;padding: 4px 7px;width: 350px" width="350">ABCDEFGHGHABCDEFGHGHABCDEFGHGHABCDEFGHGH</td>
          <td style="border: 1px solid transparent; border-left: none;border-top: none;padding: 4px 7px;width: 100px" width="100">ABCDEFGHGH</td>
          <td style="border: 1px solid transparent; border-left: none;border-top: none;padding: 4px 7px;width: 120px" width="120">ABCDEFGHGHGHGH</td>
          <td style="border: 1px solid transparent; border-left: none;border-top: none;padding: 4px 7px;width: 80px" width="80">ABCDEFGH</td>
          <td style="border: 1px solid transparent; border-left: none;border-top: none;padding: 4px 7px;width: 130px" width="130">ABCDEFGHGHGHGH</td>
        </tr>
        </tbody>
      </table>
      <div style="margin-top: -4px;font-size: 16px" :style="(page + 1 < total) ? 'margin-top: -52px': ''"><span>收货方签收：</span><span style="float:right;margin-right: 180px">签收日期：</span></div>
      <div style="margin-top: 2px;text-align: center" :style="(page + 1 < total) ? 'margin-top: 46px': ''"><span>第{{(page + 1)}}页共{{total}}页</span></div>
    </div>
  </div>
</template>

<script setup>

import {defineProps} from "vue";
defineProps(["report", 'page', 'total'])
function dot(value){
  if (value){
    let vs = value.split(".");
    return vs.join("<span style='display: inline-block;font-weight: bolder;font-size: 18px;line-height: 14px;height: 16px'>.</span>")
  }
  else {
    return ''
  }
}
</script>

<style scoped>
*{
  border: none;
  margin: 0;
  padding: 0;
  color: #333;
}
textarea.el-textarea__inner{
  resize: none;
}
</style>

<style>
.Page{
  width: 23.9cm;
  height: 13.9cm;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 15px 2cm;
  position: relative;
  font-size: 13px;
  overflow: hidden;
  text-align: left;
  font-family: "SimHei", "黑体", Arial, sans-serif;
}
</style>
